import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts--income"
export default class extends Controller {
  static targets = [
    "total",
    "income",
    "incomeTemplate",
    "formIncomesContainer"
  ]

  toggleIncome(event) {
    this.formIncomesContainerTarget.innerHTML = ""

    let income = document.getElementById(event.currentTarget.dataset.id)
    let checkbox = document.querySelector("input[type='checkbox'][data-id='" + event.currentTarget.dataset.id + "']")

    if (income.dataset.incomeSelected == "true") {
      income.dataset.incomeSelected = "false"
      checkbox.checked = false
    } else {
      income.dataset.incomeSelected = "true"
      checkbox.checked = true
    }

    this.calculate()
  }

  calculate() {
    let incomes = this.incomeTargets

    incomes.forEach(income => {
      let amount = 0
      let total = income.querySelector("[data-total-target='true']")

      income.querySelectorAll("[data-amount-target='true']").forEach((input) => {
        amount += parseInt(input.value) || 0
      })

      total.dataset.totalAmount = amount
      total.innerHTML = this.formattedAmount(amount)
    })

    this.createFormTemplates()
  }

  createFormTemplates() {
    let incomes = this.incomeTargets.filter(target => target.dataset.incomeSelected === "true")

    if (incomes.length === 0) { return }

    this.formIncomesContainerTarget.innerHTML = ""

    incomes.forEach(income => {
      let id = this.newId
      let action = income.dataset.incomeAction
      let amountCents = parseInt(income.querySelector("[data-total-target='true']").dataset.totalAmount) || 0
      let template = this.incomeTemplateTarget.cloneNode(true)

      template.innerHTML = template.innerHTML.replaceAll("NEW_RECORD", id)
      template = template.content.firstElementChild

      template.dataset.id = id
      template.setAttribute("data-admins--receipts--calculator-target", "income")
      template.querySelector("input[data-field='action']").value = action
      template.querySelector("input[data-field='amount']").value = amountCents

      this.formIncomesContainerTarget.appendChild(template)
    })
  }

  get newId() {
    let min = 100_000_000_000
    let max = 999_999_999_999

    return Math.round((Math.random() * Math.abs(max - min)) + min);
  }

  formattedAmount(value) {
    return (value / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
